import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';

export type ResizeType = {
  index: number;
  position: number;
  width: number;
  columnsWidth: { [key: number]: number };
};

type ColumnResizerProps = {
  className?: string;
  columnResizing: boolean;
  setColumnResize: (e: React.MouseEvent<HTMLDivElement>) => void;
  [key: string]: any;
};

export const ColumnResizer: React.FC<ColumnResizerProps> = ({
  className,
  setColumnResize,
  columnResizing,
  ...other
}) => {
  return (
    <div
      className={classNames(Classes.FINAL_TABLE_HEADER_RESIZER, className, {
        [Classes.FINAL_TABLE_HEADER_RESIZER_RESIZING]: columnResizing,
      })}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
        setColumnResize(e);
      }}
      {...other}
    />
  );
};
